<template>
    <span v-if="percentageValue > 0"
          class="stats-value-up">
        <i class="fa-solid fa-caret-up" />
        {{ percentageValue.toFixed(2) }}%
    </span>
    <span v-else
          class="stats-value-down">
        <i class="fa-solid fa-caret-down" />
        {{ Math.abs(percentageValue).toFixed(2) }}%
    </span>
</template>

<script>
    import { numberFormat } from '@/js/helpers/helpers';

    export default {
        name: 'StatsPercentage',
        props: {
            percentageValue: {
                type: Number,
                required: true,
            },
        },
        methods: {
            numberFormat,
        },
    };
</script>
